import React from "react"
import "./src/styles/global.css"
import { ThemeProvider } from "./src/context/ThemeContext"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
)

// Query-only updates on the same path (forecast year, country compare) must
// not jump the viewport to the top. Gatsby scrolls on every navigate() by default.
export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  const prevPath = prevRouterProps?.location?.pathname
  const nextPath = routerProps?.location?.pathname
  if (prevPath && nextPath && prevPath === nextPath) {
    return false
  }
  return true
}
